import { createApi } from '@reduxjs/toolkit/query/react';
import axiosInstance from '../../services/api/axios';

import { ApiResponse } from '../../models/apiResponse.model';
import {
	ADD_OR_UPDATE_NOTES,
	GET_NOTES,
} from '../../services/api/apiEndpoints';
import { NotePayload } from '../../models/requestModels.ts/note';
import { NoteResponse } from '../../models/responseModels.ts/noteResponse';

export const notesApiSlice = createApi({
	reducerPath: 'notesApiSlice',
	baseQuery: async (arg) => {
		//, api, extraOptions
		const { baseURL, ...axiosConfig } = arg;
		try {
			const response = await axiosInstance.request({
				...axiosConfig,
			});
			return { data: response.data };
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			console.error(error);
			return error?.response;
		}
	},
	tagTypes: ['notes'],
	endpoints: (builder) => ({
		getNotes: builder.query<
			ApiResponse<NoteResponse[]>,
			{ recruiterId: string; userEmail: string }
		>({
			query: ({ recruiterId, userEmail }) => ({
				url: `${GET_NOTES}`,
				method: 'GET',
				params: {
					recruiterId: recruiterId,
					userEmail: userEmail,
				},
			}),
			providesTags: ['notes'],
		}),
		addOrUpdateNotes: builder.mutation<ApiResponse<string>, NotePayload>({
			query: (payload) => ({
				url: `${ADD_OR_UPDATE_NOTES}`,
				method: 'POST',
				data: payload,
			}),
			invalidatesTags: ['notes'],
		}),
	}),
});

export const { useAddOrUpdateNotesMutation, useGetNotesQuery } = notesApiSlice;
